<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content [innerHtml]="contents | unsafeHtml" [style.width]="width" (pmLinkClick)="infoClicked($event)"
                    [style.height]="height" [class]="linkType"></mat-dialog-content>
